module.exports = __webpack_public_path__ + "static/media/plus-icon.5ac86924.svg";